import React, { useState, useEffect } from 'react';
// Import FaArrowLeft and FaBars
import { FaTimes, FaChevronLeft, FaChevronRight, FaArrowLeft, FaBars } from 'react-icons/fa';
// Import useNavigate
import { useNavigate } from 'react-router-dom';
// Import MobileOffcanvasMenu
import MobileOffcanvasMenu from '../MobileOffcanvasMenu';
// Import getSubcategories instead of the JSON file
import { getSubcategories } from '../../functions/Categories';

const ItineraryGallery = ({
  galleryImages,
  isModalOpen,
  selectedImageIndex,
  openModal,
  closeModal,
  showNextImage,
  showPrevImage
}) => {
  const [mobileActiveIndex, setMobileActiveIndex] = useState(0);
  // State for offcanvas menu
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  // Initialize navigate
  const navigate = useNavigate();
  // Add state for categories
  const [categories, setCategories] = useState({
    India: [],
    International: [],
    Weekend: [],
    More: []
  });

  // Fetch categories from Firebase
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const india = await getSubcategories("india");
        const international = await getSubcategories("international");
        const weekend = await getSubcategories("weekend");
        const more = await getSubcategories("more");
        
        setCategories({
          India: india || [],
          International: international || [],
          Weekend: weekend || [],
          More: more || []
        });
      } catch (error) {
        // console.error("Error fetching categories:", error);
      }
    };
    
    fetchCategories();
  }, []);

  // Function to toggle offcanvas visibility
  const handleToggleOffcanvas = (e) => {
    e.stopPropagation(); // Prevent modal from opening
    setShowOffcanvas(!showOffcanvas);
  };

  // Function to close offcanvas
  const handleCloseOffcanvas = () => {
    setShowOffcanvas(false);
  };

  const handleMobileThumbClick = (index) => {
    setMobileActiveIndex(index);
  };

  return (
    <>
      <div className="itinerary-gallery">
        {/* Desktop gallery layout */}
        <div className="gallery-thumbnails gallery-thumbnails-optimized desktop-gallery">
          {galleryImages.map((image, index) => (
            <div
              key={index}
              className={`gallery-thumbnail gallery-thumbnail-optimized ${index === 0 ? 'gallery-thumbnail-featured' : ''}`}
              onClick={() => openModal(index)}
              tabIndex={0}
              aria-label={`View image for ${image.alt}`}
              role="button"
            >
              <img
                src={image.src.replace('800x600', index === 0 ? '800x600' : '400x300')}
                alt={image.alt}
                loading="lazy"
              />
            </div>
          ))}
        </div>

        {/* Mobile gallery layout */}
        <div className="mobile-gallery">
          <div className="gallery-mobile-main" onClick={() => openModal(mobileActiveIndex)}>
            {/* Add Back Button */}
            <button 
              className="mobile-gallery-back-btn" 
              aria-label="Go back"
              onClick={(e) => {
                e.stopPropagation(); // Prevent modal from opening
                navigate(-1); // Go back to the previous page
              }}
            >
              <FaArrowLeft />
            </button>
            {/* Add Menu Button with onClick handler */}
            <button
              className="mobile-gallery-menu-btn"
              aria-label="Open menu"
              onClick={handleToggleOffcanvas} // Use toggle handler
              aria-controls="mobileMenu" // Good for accessibility
              aria-expanded={showOffcanvas} // Good for accessibility
            >
              <FaBars />
            </button>
            <img 
              src={galleryImages[mobileActiveIndex].src} 
              alt={galleryImages[mobileActiveIndex].alt} 
              loading="eager" 
            />
          </div>
          <div className="gallery-mobile-thumbs-row">
            {galleryImages.slice(0, 5).map((image, index) => (
              <div 
                key={index}
                className={`gallery-mobile-thumb ${mobileActiveIndex === index ? 'selected' : ''}`}
                onClick={(e) => {
                  e.stopPropagation();
                  handleMobileThumbClick(index);
                }}
              >
                <img src={image.src.replace('800x600', '100x100')} alt={image.alt} loading="lazy" />
              </div>
            ))}
            {galleryImages.length > 5 && (
              <div 
                className="gallery-mobile-thumb more"
                onClick={(e) => {
                  e.stopPropagation();
                  openModal(5);
                }}
              >
                +{galleryImages.length - 5}
              </div>
            )}
          </div>
        </div>
      </div>

      {isModalOpen && (
        <div className="gallery-modal" onClick={closeModal}>
          <button className="close-modal" onClick={closeModal} aria-label="Close image gallery"><FaTimes /></button>
          <button className="prev-btn" onClick={showPrevImage} aria-label="Previous image"><FaChevronLeft /></button>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <img 
              src={galleryImages[selectedImageIndex].src} 
              alt={galleryImages[selectedImageIndex].alt} 
              className="modal-image" 
            />
          </div>
          <button className="next-btn" onClick={showNextImage} aria-label="Next image"><FaChevronRight /></button>
        </div>
      )}

      {/* Render the MobileOffcanvasMenu component with props */}
      <MobileOffcanvasMenu
        show={showOffcanvas}
        handleClose={handleCloseOffcanvas}
        categories={categories}
      />
    </>
  );
};

export default ItineraryGallery;
